export default __webpack_public_path__ + "static/ayvakit-logo-hero-gist-acc65f56ed8c02303e84dd3bc4371a0d.png";